import Timer from '../timer';
import Events from '../timer/Events';
import AuthManager from '@/common/auth/Manager';
import AuthEvents from '@/common/auth/Events';

export default {
  setSettings({commit}, settings) {
    commit('setSettings', settings);
  },
  setCurrentInterval({commit}, interval = {}) {
    commit('setCurrentInterval', interval);
  },
  setCurrentIntervalTime({commit}, time) {
    commit('setCurrentIntervalTime', time);
  },
  addInterval({commit}) {
    commit('addInterval');
  },
  setIntervals({commit}, intervals) {
    commit('setIntervals', intervals);
  },
  setCurrentIntervalBehaviourHappenedAt({commit}, value) {
    commit('setCurrentIntervalBehaviourHappenedAt', value);
  },
  setIntervalDuration({commit}, params) {
    commit('setIntervalDuration', params);
  },
  setAuditor({commit}, object) {
    commit('setAuditor', object);
  },
  setAssignee({commit}, object) {
    commit('setAssignee', object);
  },
  setStartedAt({commit}, value) {
    commit('setStartedAt', value);
  },
  setFinishedAt({commit}, value) {
    commit('setFinishedAt', value);
  },
  setUuid({commit}, uuid) {
    commit('setUuid', uuid);
  },
  setIsSessionStarted({commit}, value) {
    commit('setIsSessionStarted', value);
  },
  setShouldStartIntervalAutomatically({commit}, value) {
    commit('setShouldStartIntervalAutomatically', value);
  },
  clearSession({commit, dispatch}) {
    commit('setFinishedAt', null);
    commit('setStartedAt', null);
    commit('setIntervals', []);
    commit('setAuditor', {});
    commit('setAssignee', {});
    commit('setCurrentInterval', {
      index: null,
      duration: null,
      current: 0,
      behaviourHappenedAt: null,
    });
    commit('setSettings', {
      behaviourTypeId: null,
      intervalDurationValue: null,
      intervalDurationUnitId: null,
      aimTypeId: null,
    });
    commit('setUuid', null);
    commit('setIsSessionStarted', false);
    commit('setShouldStartIntervalAutomatically', false);
    dispatch('destroyTimer');
  },
  stopTimer() {
    Timer.stop();
  },
  resetTimer() {
    Timer.reset();
  },
  async startTimer({dispatch, commit}) {
    await dispatch('initTimer');
    await commit('setTimerConfig');
    Timer.start();
  },
  async destroyTimer({commit, dispatch}) {
    await dispatch('resetTimer');
    Timer.removeEvent();
  },
  async initTimer({commit, dispatch}) {
    await dispatch('destroyTimer');
    Timer.on(Events.TICK, ({current}) => {
      dispatch('setCurrentIntervalTime', current);
    });
    Timer.on(Events.TO_TIME_REACHED, () => {
      dispatch('addInterval');
    });
    AuthManager.on(AuthEvents.BEFORE_UNAUTHORIZE, () => {
      dispatch('destroyTimer');
      return true;
    });
  },
  async onBehaviourHappened({commit, dispatch}) {
    await dispatch('stopTimer');
    await dispatch('setCurrentIntervalBehaviourHappenedAt',
        Timer.getCurrentTime());
    await dispatch('addInterval');
    await dispatch('resetTimer');
  },
  setIntervalEnable({commit}, value) {
    commit('setIntervalEnable', value);
  },
};


// WEBPACK FOOTER //
// ./src/modules/dro/vuex/actions.js